import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    wwwconfig: ""
  },
  mutations: {
    setconfig: (state, data) => (state.wwwconfig = data)
  },
  getters: {
    getConfig: state => {
      return state.wwwconfig;
    }
  },
  actions: {},
  modules: {}
});
